import type { PriceBookItemType } from "@/lib/price-book";

export const PRICE_BOOK_UNIT_OPTIONS = [
  "ea",
  "box",
  "bag",
  "sheet",
  "bucket",
  "roll",
  "ft",
  "lf",
  "sq ft",
  "gal",
  "cu yd",
  "lb",
] as const;

export const PRICE_BOOK_LABOR_UNIT_OPTIONS = ["hrs"] as const;

export function getPriceBookUnitOptionsForType(type: PriceBookItemType) {
  if (type === "LABOR") return PRICE_BOOK_LABOR_UNIT_OPTIONS;
  if (type === "OTHER") return ["ea"] as const;
  return PRICE_BOOK_UNIT_OPTIONS;
}

export function getDefaultPriceBookUnitForType(type: PriceBookItemType) {
  return getPriceBookUnitOptionsForType(type)[0];
}

export function resolvePriceBookUnitForType(
  type: PriceBookItemType,
  unit?: string | null,
) {
  const options = getPriceBookUnitOptionsForType(type);
  const value = unit?.trim();
  return value && (options as readonly string[]).includes(value)
    ? value
    : getDefaultPriceBookUnitForType(type);
}
